module.exports = __webpack_public_path__ + "38c02bffa8f052d86b7ff2d60e7f45ba.svg";